import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, MapPin, Phone, Star, ArrowUpRight } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-midnight border-t border-white/5 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">
          {/* Brand */}
          <div className="space-y-8">
            <Link to="/" className="flex items-center space-x-3">
              <Star className="w-6 h-6 text-gold" />
              <span className="text-xl font-serif font-bold tracking-[0.15em] text-white uppercase">
                Astro<span className="text-gold italic">Vidya</span>
              </span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed font-light">
            Guiding your journey through the stars. AstroVidya.net combines ancient wisdom with modern technology to help you navigate your cosmic destiny.
            </p>
            <div className="flex space-x-5">
              {[Instagram, Facebook, Twitter].map((Icon, idx) => (
                <a key={idx} href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-gray-500 hover:text-gold hover:border-gold transition-all duration-300">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-8">Offerings</h4>
            <ul className="space-y-5">
              {[
                { name: 'Birth Chart Readings', path: '/services/birth-chart' },
                { name: 'Zodiac Jewelry', path: '/shop' },
                { name: 'Live Consultations', path: '/services/consultations' },
                { name: 'Cosmic Map', path: '/cosmic-map' }
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-500 hover:text-gold text-sm transition-all duration-300 flex items-center group">
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-8">Support</h4>
            <ul className="space-y-5">
              {[
                { name: 'Contact Us', path: '/contact' },
                { name: 'Privacy Policy', path: '/privacy-policy' },
                { name: 'Refund Policy', path: '/refund-policy' },
                { name: 'Terms & Services', path: '/terms-and-services' }
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-500 hover:text-gold text-sm transition-all duration-300 flex items-center group">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-8">Contact</h4>
            <ul className="space-y-6">
              <li className="flex items-start space-x-4">
                <Mail className="w-4 h-4 text-gold shrink-0 mt-1" />
                <div>
                  <p className="text-white text-sm font-medium">Email Us</p>
                  <p className="text-gray-500 text-xs mt-1">hello@astrovidya.net</p>
                </div>
              </li>
              <li className="flex items-start space-x-4">
                <MapPin className="w-4 h-4 text-gold shrink-0 mt-1" />
                <div>
                  <p className="text-white text-sm font-medium">Our Office</p>
                  <p className="text-gray-500 text-xs mt-1">Boomtech Solution Private Limited<br />India</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-12 flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <p className="text-gray-600 text-[10px] uppercase tracking-[0.2em]">
            © 2026 AstroVidya.net. Crafted for the cosmic soul.
          </p>
          <div className="flex items-center space-x-8">
            <p className="text-gray-600 text-[10px] uppercase tracking-[0.2em]">
              By Boomtech Solution Private Limited
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
